import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import React from 'react'



const SignUp = React.lazy(() => import('./components/MemberSignUp/MemberSignUp'))
const ThankYou = React.lazy(() => import('./components/MemberSignUp/MemberSignUpMessage'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
            <Route exact path="/signup" name="SignUp Page" element={<SignUp />} />
            <Route path="/thankYou" name="Thank You" element={<ThankYou />} />
        </Routes>

    </BrowserRouter>
  );
}

export default App;
